import { Badge, Button, Tooltip } from '@orbita-ui/core';
import { Transferencia } from 'core/cuenta/models/Transferencia';
import { TablePlaceholder } from 'shared/placeholders';
import { Table } from 'shared/table';
import { TableComponentParams } from 'shared/table/hoc/withPagination';
import { formatCurrency, formatFullDate } from 'shared/utils';
import { useAuth } from 'auth/hooks/useAuth';

export interface TransfersTableProps extends TableComponentParams<Transferencia> {
  onDownloadComprobante?: (transfer: Transferencia) => void;
}

const getStatusColor = (transferencia: Transferencia) => {
  switch (transferencia.estado) {
    case 'Completada':
      return 'green';
    case 'Pendiente':
      return 'yellow';
    case 'Rechazada':
      return 'red';
  }
};

export const TransfersTable = ({
  tableContent,
  placeholderRows,
  onDownloadComprobante,
}: TransfersTableProps) => {

  const { user } = useAuth();
  const isTarjetaUser = user?.tipoUsuario === 'TARJETA';
  const isCentroCostoUser = user?.tipoUsuario === 'CENTRO_COSTO';

  return (
    <Table
      thead={
        <tr>
          <th>Cuenta origen</th>
          <th>Cuenta destino</th>
          <th>Fecha</th>
          <th>Monto</th>
          <th>Usuario</th>
          <th>Estado</th>
          <th></th>
        </tr>
      }
      tbody={
        <>
          {tableContent?.map((row) => (
            <tr key={`transferencia${row.id}`} data-testid={`transferencia${row.id}`}>
              <td className="align-middle">{`${row.origen.denominacion} / ${row.origen.numeroCuenta}`}</td>
              <td className="align-middle">{`${row.destino.denominacion} / ${row.destino.numeroCuenta}`}</td>
              <td className="align-middle">{`${formatFullDate(row.fecha)}`}</td>
              <td className="align-middle">{`${formatCurrency(row.monto)}`}</td>
              <td className="align-middle">{row.username}</td>
              <td className="align-middle">
                <Badge color={getStatusColor(row)} emphasis="high" label={row.estado} />
              </td>
              <td className="align-middle text-center">
                {row.estado === 'Completada' &&
                  (
                    isCentroCostoUser ||
                    (isTarjetaUser && row.origen.tipoCuenta === 'TARJETA')
                  ) && (
                    <Tooltip text="Descargar comprobante" position="left">
                      <Button
                        type="button"
                        color="inverted"
                        icon="ArrowDownCircleIcon"
                        size="small"
                        onClick={() => {
                          onDownloadComprobante?.(row);
                        }}
                      />
                    </Tooltip>
                  )}
              </td>
            </tr>
          )) || <TablePlaceholder cols={7} rows={placeholderRows || 5} />}
        </>
      }
    />
  );
};